import React from 'react';
import { useRifm } from 'rifm';
import { useLocale } from 'locale';
import { Input, InputProps } from '../Input';

const NumberInput: React.FC<InputProps & { disableComma?: boolean; }> = (props) => {
  const { formatMoney } = useLocale();
  const { disableComma, ...rest } = props;

  const format = (str: string) => {
    const emptyValue = formatMoney(0);

    if (!str) return emptyValue;
    const r = parseInt(String(str).replace(/[^\d]+/gi, ''), 10);

    if (!r) return emptyValue;
    return formatMoney(r);
  };

  const handleChange = (str: string) => props.onChange({
    currentTarget: {
      value: str.replace(/[^\d]+/gi, ''),
    },
  } as React.ChangeEvent<HTMLInputElement>);

  const rifm = useRifm({
    value: props.value as string,
    onChange: handleChange,
    format,
  });

  return (
    <Input
      {...rest}
      {...(disableComma ? {} : { value: rifm.value, onChange: rifm.onChange })}
      type="tel"
      style={{ direction: 'rtl' }}
    />
  );
};

export default NumberInput;
